import { MerchantProfile } from 'merchant-api/types';
import { useApplication } from 'merchant-api/unified';
import { queryOptions, useQuery, UseQueryResult } from '@tanstack/react-query';
import { spiceroad } from '..';

export interface MerchantProfileProps {
  isLoadingMerchantProfile: boolean;
  merchantProfileInfo: MerchantProfile | undefined;
  isErrorMerchantProfile: any;
  bankName: string | undefined;
  accountNumber: string | undefined;
  applicationType: string | undefined;
  query: UseQueryResult<MerchantProfile>;
}

const getMerchantProfileData = () =>
  spiceroad
    .get<MerchantProfile>('/v2/merchant/profile',{validateStatus: (status) => [200, 404].includes(status)})
    .then((res) => res.data);

export const getMerchantProfileOpts = queryOptions<MerchantProfile>({
  queryKey: ['merchantProfile'],
  queryFn: getMerchantProfileData,
});

export function getMerchantProfile(): MerchantProfileProps {
  const { applicationData } = useApplication();
  const query = useQuery({
    ...getMerchantProfileOpts,
  });
  const { data, error, isLoading } = query;
  return {
    isLoadingMerchantProfile: isLoading,
    merchantProfileInfo: data,
    isErrorMerchantProfile: error,
    bankName: data?.merchantBankInfo?.bankName,
    accountNumber: data?.merchantBankInfo?.accountNumber,
    applicationType: applicationData?.type!,
    query
  }
}

export default getMerchantProfile;
